import styled from '@emotion/styled';

import { PrimaryButton, TableActionButton } from '@/components/common/form/formPageStyles';
import { pageSectionLayout } from '@/styles/pageLayout';

export { PrimaryButton as PaymentButton, TableActionButton };

export const Container = styled.div`
	${pageSectionLayout}
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const Title = styled.h2`
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	@media (max-width: 900px) {
		flex-direction: column;
		align-items: unset;
		gap: 2rem;
	}
`;
export const SubTitle = styled.h3`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export const DescriptionBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
`;
export const Description = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;

export const Table = styled.table`
	width: 100%;
	border-collapse: collapse;
`;

export const TableHead = styled.thead``;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr``;

export const TableHeadCell = styled.th`
	background-color: #f8f9fa;
	color: white;
	padding: 1rem 1.2rem;
	height: 5.2rem;
	text-align: left;
	border-right: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	color: #212529;
	text-align: center;
	vertical-align: middle;
`;

export const TableCellSuceess = styled.p`
	font-size: 1.6rem;
	font-weight: 400;
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #16a34a;
`;
export const TableCellDanger = styled.p`
	font-size: 1.6rem;
	font-weight: 400;
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #dc2626;
`;
export const TableCell = styled.td`
	background-color: #fff;
	height: 5.2rem;
	padding: 10px 15px;
	border-right: 2px solid white;
	border-bottom: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	text-align: center;
	vertical-align: middle;
	border-bottom: 1px solid rgba(173, 181, 189, 0.4);
`;
export const PointCel = styled(TableCell)`
	color: ${(props) => props.theme.colors.primary400};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
`;
export const Button = TableActionButton;

export const ButtonBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.scale.spaceSm};
`;

export const CompleteStatus = TableActionButton;
export const MobileCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
	padding: 2rem;
	background-color: #f1f3f5;
`;
export const CardContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
`;
export const MenuBox = styled.div`
	display: flex;
	gap: 1.6rem;
	font-size: 1.6rem;
	font-weight: 400;
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export const CardMenu = styled.div`
	color: #495057;
	font-weight: 700;
	min-width: 6rem;
`;
export const PointMenu = styled(CardMenu)`
	color: ${(props) => props.theme.colors.primary400};
`;
